module.exports = __webpack_public_path__ + "static/6-9553b48f299b2a09f3e00460a4473f6c.pdf";